import { FC, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { GenderType } from "../helpers/Enums";

export type EditHeightProps = {
    onSave: (selectedHeight: number) => void;

    title: string | undefined;
    subtitle: string | undefined;
    buttonText: string;
}


const EditHeight: FC<EditHeightProps> = ({ onSave, title, subtitle, buttonText }) => {
    const [selectedHeight, setSelectedHeight] = useState<number | null>(0);
    const resgiter = useSelector((state: RootState) => state.signup);
    const member = useSelector((state: RootState) => state.member);

    useEffect(() => {
        if (member.height !== 0 && member.height !== null) {
            setSelectedHeight(member.height);
        }

    }, [])

    const heightOptions = () => {
        const optionsArray: JSX.Element[] = [];
        optionsArray.push(<option key={"option0"} value={0}>{"בחירה"}</option>)
        for (let i = 150; i <= 210; i++) {
            optionsArray.push(<option key={"option" + i} value={i}>{i + ' ס"מ'}</option>)
        }
        return optionsArray;
    }

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSave(selectedHeight!);
    }






    return (
        <div className="content_sec wf-section">

            <div className="signup_top_info">
                <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                <h2 className="signup_title">{title}</h2>
                <div>{subtitle}</div>
            </div>

            <div className="login_sec w-form">
                <form onSubmit={handleSubmit}>
                    <div className="form_field_content login">
                        <div className="field_block">
                            <select value={selectedHeight!} id="field-4" name="field-4" data-name="Field 4" className="txt_field grow w-select" onChange={(e) => { setSelectedHeight(parseInt(e.target.value)) }}>
                                {heightOptions()}
                            </select>
                        </div>
                        <div className="form_allert">----------------------------</div>

                        <a href="#" className="skip_link" onClick={() => onSave(0)}>
                            {(resgiter.genderId === GenderType.MALE || member.genderId === GenderType.MALE) ? "דלג" : "דלגי"}
                        </a>
                    </div>
                    <div className="form_send_group">
                        <div className="form_buttons_group signup">
                            <input type="submit" data-wait="" className="button w-button" value={buttonText} />
                        </div>
                    </div>
                </form>
            </div>
        </div>


    );
}

export default EditHeight;